import React, { useState } from "react";
import Layout from "../../Components/Layout";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

function CreateTenant() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  const [logoFile, setLogoFile] = useState(null);

  const [formData, setFormData] = useState({
    tenantName: "",
    registrationNumber: "",
    dateOfEstablishment: "",
    email: "",
    countryCode: "+91",
    mobileNumber: "",
    websiteUrl: "",
    logoUrl: "",
    tenantType: "",

    // Address
    landMark: "",
    streetLine1: "",
    streetLine2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    metadata: "",
    primaryAddress: true,

    // Social Media
    facebook: "",
    linkedin: "",
    instagram: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async () => {
    try {
      const tenantDTO = {
        tenantName: formData.tenantName,
        registrationNumber: formData.registrationNumber,
        dateOfEstablishment: formData.dateOfEstablishment,
        email: formData.email,
        countryCode: formData.countryCode,
        mobileNumber: formData.mobileNumber,
        websiteUrl: formData.websiteUrl,
        logoUrl: formData.logoUrl,
        tenantType: formData.tenantType,

        addressDTO: {
          landMark: formData.landMark,
          streetLine1: formData.streetLine1,
          streetLine2: formData.streetLine2,
          city: formData.city,
          state: formData.state,
          postalCode: formData.postalCode,
          country: formData.country,
          metadata: formData.metadata,
          primaryAddress: formData.primaryAddress,
        },

        socialMediaLinks: {
          facebook: formData.facebook,
          linkedin: formData.linkedin,
          instagram: formData.instagram,
        },
      };

      console.log("tenantDTO", tenantDTO);

      const multipartData = new FormData();

      multipartData.append(
        "tenantDTO",
        new Blob([JSON.stringify(tenantDTO)], {
          type: "application/json",
        }),
      );

      if (logoFile) {
        multipartData.append("orgLogoUrl", logoFile);
      }

      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/tenants`,
        multipartData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success("Tenant created successfully");

      navigate("/tenent");
    } catch (error) {
      console.error(error);
      toast.error("Failed to create tenant");
    }
  };

  return (
    <Layout>
      <ToastContainer />

      <div className="backgound-main-content p-4">
        <h3>Create Tenant</h3>

        <div className="row mt-4">
          {/* Tenant Name */}
          <div className="col-md-6 mb-3">
            <label>Tenant Name</label>
            <input
              type="text"
              className="form-control"
              name="tenantName"
              value={formData.tenantName}
              onChange={handleChange}
            />
          </div>

          {/* Registration Number */}
          <div className="col-md-6 mb-3">
            <label>Registration Number</label>
            <input
              type="text"
              className="form-control"
              name="registrationNumber"
              value={formData.registrationNumber}
              onChange={handleChange}
            />
          </div>

          {/* Email */}
          <div className="col-md-6 mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          {/* Country Code */}
          <div className="col-md-3 mb-3">
            <label>Country Code</label>
            <input
              type="text"
              className="form-control"
              name="countryCode"
              value={formData.countryCode}
              onChange={handleChange}
            />
          </div>

          {/* Mobile */}
          <div className="col-md-3 mb-3">
            <label>Mobile Number</label>
            <input
              type="text"
              className="form-control"
              name="mobileNumber"
              value={formData.mobileNumber}
              onChange={handleChange}
            />
          </div>

          {/* Website */}
          <div className="col-md-6 mb-3">
            <label>Website URL</label>
            <input
              type="text"
              className="form-control"
              name="websiteUrl"
              value={formData.websiteUrl}
              onChange={handleChange}
            />
          </div>

          {/* Logo URL */}
          <div className="col-md-6 mb-3">
            <label>Logo URL</label>
            <input
              type="text"
              className="form-control"
              name="logoUrl"
              value={formData.logoUrl}
              onChange={handleChange}
            />
          </div>

          {/* Tenant Type */}
<div className="col-md-6 mb-3">
  <label className="form-label">Tenant Type</label>
  <select
    className="form-select"
    name="tenantType"
    value={formData.tenantType}
    onChange={handleChange}
  >
    <option value="">Select Tenant Type</option>
    <option value="TRAINING_INSTITUTE">
      Training Institute
    </option>
    <option value="CORPORATE_TRAINING">
      Corporate Training
    </option>
    <option value="NGO">
      NGO
    </option>
    <option value="BUSINESS">
      Business
    </option>
  </select>
</div>

          {/* Date */}
          <div className="col-md-6 mb-3">
            <label>Date Of Establishment</label>
            <input
              type="date"
              className="form-control"
              name="dateOfEstablishment"
              value={formData.dateOfEstablishment}
              onChange={handleChange}
            />
          </div>

          {/* Upload Logo */}
          <div className="col-md-6 mb-3">
            <label>Upload Logo</label>
            <input
              type="file"
              className="form-control"
              onChange={(e) => setLogoFile(e.target.files[0])}
            />
          </div>

          {/* Address Section */}
          <div className="col-12 mt-3">
            <h5>Address Details</h5>
          </div>

          <div className="col-md-6 mb-3">
            <label>Landmark</label>
            <input
              type="text"
              className="form-control"
              name="landMark"
              value={formData.landMark}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Street Line 1</label>
            <input
              type="text"
              className="form-control"
              name="streetLine1"
              value={formData.streetLine1}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Street Line 2</label>
            <input
              type="text"
              className="form-control"
              name="streetLine2"
              value={formData.streetLine2}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>City</label>
            <input
              type="text"
              className="form-control"
              name="city"
              value={formData.city}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>State</label>
            <input
              type="text"
              className="form-control"
              name="state"
              value={formData.state}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>Postal Code</label>
            <input
              type="text"
              className="form-control"
              name="postalCode"
              value={formData.postalCode}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Country</label>
            <input
              type="text"
              className="form-control"
              name="country"
              value={formData.country}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-6 mb-3">
            <label>Metadata</label>
            <input
              type="text"
              className="form-control"
              name="metadata"
              value={formData.metadata}
              onChange={handleChange}
            />
          </div>

          {/* Primary Address */}
          <div className="col-md-6 mb-3">
            <div className="form-check mt-4">
              <input
                type="checkbox"
                className="form-check-input"
                name="primaryAddress"
                checked={formData.primaryAddress}
                onChange={handleChange}
              />

              <label className="form-check-label">Primary Address</label>
            </div>
          </div>

          {/* Social Media */}
          <div className="col-12 mt-3">
            <h5>Social Media Links</h5>
          </div>

          <div className="col-md-4 mb-3">
            <label>Facebook</label>
            <input
              type="text"
              className="form-control"
              name="facebook"
              value={formData.facebook}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>LinkedIn</label>
            <input
              type="text"
              className="form-control"
              name="linkedin"
              value={formData.linkedin}
              onChange={handleChange}
            />
          </div>

          <div className="col-md-4 mb-3">
            <label>Instagram</label>
            <input
              type="text"
              className="form-control"
              name="instagram"
              value={formData.instagram}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex gap-3 mt-4">
          <button className="btn btn-secondary" onClick={() => navigate(-1)}>
            Cancel
          </button>

          <button className="btn btn-info text-white" onClick={handleSubmit}>
            Create Tenant
          </button>
        </div>
      </div>
    </Layout>
  );
}

export default CreateTenant;
